module.exports = __webpack_public_path__ + "img/img-related15.b0feeb08.jpg";